module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "nav-box"
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  })])])]), _c('div', {
    staticClass: "access"
  }, [_c('div', {
    staticClass: "access-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require("./festival/word-ACCESS-ALL.png"),
      "alt": "ACCESS-ALL"
    }
  })]), _c('div', {
    staticClass: "small-icon"
  }, [_c('img', {
    attrs: {
      "src": require("./festival/icon-tail.png"),
      "alt": "icon"
    }
  })]), _c('div', {
    staticClass: "summary"
  }, [_c('span', [_vm._v("三大品类")]), _c('span', [_vm._v("快速办理")]), _c('span', [_vm._v("先用后付")])]), _c('ul', {
    staticClass: "category"
  }, [_c('li', [_c('p', {
    staticClass: "top station"
  }, [_c('span', [_vm._v("园区工位")])]), _c('p', {
    staticClass: "down"
  }, [_vm._v("园区工位")])]), _c('li', {
    staticClass: "has-margin"
  }, [_c('p', {
    staticClass: "top member"
  }, [_c('span', [_vm._v("漫游会员")])]), _c('p', {
    staticClass: "down"
  }, [_vm._v("漫游会员")])]), _c('li', [_c('p', {
    staticClass: "top election"
  }, [_c('span', [_vm._v("八戒严选")])]), _c('p', {
    staticClass: "down"
  }, [_vm._v("八戒严选")])])])])]), _c('div', {
    staticClass: "special-offer"
  }, [_c('div', {
    staticClass: "special-offer-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require("./festival/word-SPECIAL-OFFER.png"),
      "alt": "word-SPECIAL-OFFER"
    }
  })]), _c('div', {
    staticClass: "small-icon"
  }, [_c('img', {
    attrs: {
      "src": require("./festival/icon-tail.png"),
      "alt": "icon"
    }
  })]), _c('ul', {
    staticClass: "offer-item"
  }, [_c('li', [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("./festival/icon-service.png"),
      "alt": "service"
    }
  })]), _c('div', {
    staticClass: "words"
  }, [_c('h2', [_vm._v("免费服务")]), _c('p', [_vm._v("专业咨询免费提供")])])]), _c('li', {
    staticClass: "deviation"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("./festival/icon-handle.png"),
      "alt": "service"
    }
  })]), _c('div', {
    staticClass: "words"
  }, [_c('h2', [_vm._v("在线办理")]), _c('p', [_vm._v("最快30分钟内完成审批放款")])])]), _c('li', [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("./festival/icon-flexible.png"),
      "alt": "service"
    }
  })]), _c('div', {
    staticClass: "words"
  }, [_c('h2', [_vm._v("期数灵活")]), _c('p', [_vm._v("3期、6期、12期按需选择")])])]), _c('li', {
    staticClass: "deviation"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("./festival/icon-quota.png"),
      "alt": "service"
    }
  })]), _c('div', {
    staticClass: "words"
  }, [_c('h2', [_vm._v("额度更高")]), _c('p', [_vm._v("1000到10万都能分期")])])])])])]), _c('div', {
    staticClass: "contact-us"
  }, [_c('div', {
    staticClass: "contact-us-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("更多联系方式")])]), _c('ul', {
    staticClass: "detail"
  }, [_c('li', {
    staticClass: "webchat"
  }, [_c('p', [_vm._v("微信咨询")]), _c('img', {
    attrs: {
      "src": require("./festival/icon-erweima.png"),
      "alt": "二维码"
    }
  })]), _c('li', {
    staticClass: "has-margin phone-mail"
  }, [_c('p', [_vm._v("联系电话")]), _c('h2', [_vm._v("023-88392602")])]), _c('li', {
    staticClass: "phone-mail"
  }, [_c('p', [_vm._v("电子邮箱")]), _c('h2', [_vm._v("kangkang@zbj.com")])])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7601c44a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7601c44a","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@zbj/vue-mixin-loader?{"mixinPath":"D://zhubajie//Project//nodejs-zbjfins-web//app//resource//global//css//mixin//mixin.less"}!./app/resource/page/index/views/eightFestival.vue
// module id = 1200
// module chunks = 2